// 구글맵 어댑터 — MapPicker 공통 인터페이스 { load, createPicker }
// SDK는 index.html 에서 정적 로드되므로 load()는 즉시 resolve.

export const load = () => {
    if (window.google && window.google.maps) return Promise.resolve(window.google);
    // index.html async 로드가 아직 안 끝난 경우 잠깐 대기
    return new Promise((resolve, reject) => {
        let tries = 0;
        let t = setInterval(() => {
            if (window.google && window.google.maps) {
                clearInterval(t);
                resolve(window.google);
            } else if (++tries > 40) {
                clearInterval(t);
                reject(new Error("구글맵 SDK 로드 실패"));
            }
        }, 100);
    });
};

// container 에 지도/마커/인포윈도우 생성. handlers: { onSelect(lat,lon), onMove(lat,lon) }
// 반환 handle: { recenter(lat,lon), destroy() }
export const createPicker = (container, initPos, handlers) => {
    let g = window.google.maps;

    let map = new g.Map(container, {
        center: { lat: initPos.lat, lng: initPos.lon },
        zoom: 10,
        disableDefaultUI: false,
        zoomControl: true,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        clickableIcons: false
    });

    let marker = new g.Marker({
        position: { lat: initPos.lat, lng: initPos.lon },
        map: map,
        draggable: true
    });

    let infoWindow = new g.InfoWindow({
        content: '<button type="button" class="mapPickerSelectBtn">위치 선택</button>',
        disableAutoPan: true,
        pixelOffset: new g.Size(0, 8)
    });
    infoWindow.open(map, marker);

    infoWindow.addListener('domready', () => {
        let btn = document.querySelector('.mapPickerSelectBtn');
        if (btn) {
            btn.onclick = () => {
                let p = marker.getPosition();
                if (handlers.onSelect) handlers.onSelect(p.lat(), p.lng());
            };
        }
    });

    marker.addListener('dragend', () => {
        let p = marker.getPosition();
        if (handlers.onMove) handlers.onMove(p.lat(), p.lng());
        infoWindow.open(map, marker);
    });

    map.addListener('click', (e) => {
        marker.setPosition(e.latLng);
        if (handlers.onMove) handlers.onMove(e.latLng.lat(), e.latLng.lng());
        infoWindow.open(map, marker);
    });

    return {
        recenter: (lat, lon) => {
            let p = { lat, lng: lon };
            map.setCenter(p);
            map.setZoom(13);
            marker.setPosition(p);
            infoWindow.open(map, marker);
        },
        destroy: () => { }
    };
};
